var _rect, _rect2, _rect3, _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServer503(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 121,
    viewBox: "0 0 222 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 222,
    height: 120,
    transform: "translate(0 0.5)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.4673,
    y: 85.4443,
    width: 135.449,
    height: 28.2676,
    rx: 4,
    fill: "white",
    stroke: "#C7C7CC",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.4673,
    y: 57.1768,
    width: 135.449,
    height: 28.2676,
    rx: 4,
    fill: "white",
    stroke: "#C7C7CC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4673 28.9092H178.916V53.1767C178.916 55.3859 177.125 57.1767 174.916 57.1767H47.4673C45.2581 57.1767 43.4673 55.3859 43.4673 53.1767V28.9092Z",
    fill: "white",
    stroke: "#C7C7CC",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.256 6.70728H64.1307C62.9754 6.70728 61.8765 7.2068 61.1169 8.07729L43.5528 28.2048C43.3834 28.3989 43.5213 28.7022 43.7789 28.7021L178.606 28.6517C178.864 28.6516 179.002 28.3481 178.832 28.1542L161.266 8.07365C160.507 7.20535 159.409 6.70728 158.256 6.70728Z",
    fill: "#FDFDFD",
    stroke: "#C7C7CC",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 164.72,
    cy: 43.0431,
    r: 5.30017,
    fill: "#F8F8F8",
    stroke: "#C7C7CC",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.72,
    cy: 71.3107,
    r: 5.30017,
    fill: "#F8F8F8",
    stroke: "#C7C7CC",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.72,
    cy: 99.5782,
    r: 5.30017,
    fill: "#F8F8F8",
    stroke: "#C7C7CC",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.233 43.043H131.439",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.233 71.3105H131.439",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.233 99.5781H131.439",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.971 105.467L106.971 93.6892",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.971 77.1998L106.971 65.4216",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.971 48.9322L106.971 37.1541",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.77 105.467L85.77 93.6892",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.77 77.1998L85.77 65.4216",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.77 48.9322L85.77 37.1541",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3706 105.467L96.3706 93.6892",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3706 77.1998L96.3706 65.4216",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3706 48.9322L96.3706 37.1541",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1699 105.467L75.1699 93.6892",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1699 77.1998L75.1699 65.4216",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1699 48.9322L75.1699 37.1541",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5693 105.467L64.5693 93.6892",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5693 77.1998L64.5693 65.4216",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5693 48.9322L64.5693 37.1541",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9692 105.467L53.9692 93.6892",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9692 77.1998L53.9692 65.4216",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9692 48.9322L53.9692 37.1541",
    stroke: "#C7C7CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6235_14460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.019 43.8254C108.552 41.1237 112.445 41.1236 113.978 43.8252L139.244 88.3604C140.757 91.027 138.831 94.3342 135.765 94.3342L85.2348 94.3342C82.169 94.3342 80.2429 91.0271 81.7556 88.3606L107.019 43.8254Z",
    fill: "white",
    stroke: "#DCAE1D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.936 57.1936L110.936 75.555",
    stroke: "#DCAE1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.935 83.4072L110.936 83.3961",
    stroke: "#DCAE1D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6235_14460",
    x: 72.6499,
    y: 32.6658,
    width: 75.7007,
    height: 67.8342,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6235_14460"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6235_14460",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer503);
export default __webpack_public_path__ + "static/media/server_503.d2b37827f467264176d6c22aae979e14.svg";
export { ForwardRef as ReactComponent };